import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowDownLeftCircleLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M3.793 3.793C5.713 1.873 8.513 1 12 1s6.287.873 8.207 2.793S23 8.513 23 12s-.872 6.287-2.793 8.207C18.287 22.127 15.487 23 12 23s-6.287-.872-8.207-2.793C1.873 18.287 1 15.487 1 12s.873-6.287 2.793-8.207m1.414 1.414C3.794 6.62 3 8.821 3 12s.794 5.38 2.207 6.793S8.821 21 12 21s5.38-.794 6.793-2.207S21 15.179 21 12s-.794-5.38-2.207-6.793S15.179 3 12 3s-5.38.794-6.793 2.207'
      clipRule='evenodd'
    />
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M15.707 8.293a1 1 0 0 1 0 1.414l-3.043 3.043 1.543 1.543A1 1 0 0 1 13.5 16H9a1 1 0 0 1-1-1v-4.5a1 1 0 0 1 1.707-.707l1.543 1.543 3.043-3.043a1 1 0 0 1 1.414 0'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowDownLeftCircleLine)
export default ForwardRef
